/** Case-insensitive alphabetical sort for model/MTO rows with a display name. */
export function sortByDisplayName<T extends { name?: unknown }>(rows: T[]): T[] {
  return [...rows].sort((a, b) =>
    String(a.name ?? '').localeCompare(String(b.name ?? ''), undefined, { sensitivity: 'base' })
  );
}

/** Sort assignment rows by linked catalog model label. */
export function sortByModelLabel<T extends { model_name?: unknown; model_id?: unknown }>(
  rows: T[]
): T[] {
  return [...rows].sort((a, b) => {
    const la = String(a.model_name ?? a.model_id ?? '');
    const lb = String(b.model_name ?? b.model_id ?? '');
    return la.localeCompare(lb, undefined, { sensitivity: 'base' });
  });
}
